import { useMutation, useQuery } from '@tanstack/react-query';

import { incentiveCampaign } from 'services';

export const useQueryIncentiveCampaignOptin = (campaignId?: string) => ({
  ...useQuery({
    queryKey: [campaignId],
    queryFn: () =>
      incentiveCampaign.optin.get({
        queryKey: [campaignId],
        meta: undefined,
      }),
    staleTime: 2 * 60 * 1000,
    refetchOnWindowFocus: false,
  }),
});

export const useMutationIncentiveCampaignOptin = (campaignId: string) =>
  useMutation(['INCENTIVE_CAMPAIGN_OPTIN_MUTATION', campaignId], incentiveCampaign.optin.post);
